import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/softs/ofdconverter/appLogo.png")